<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="[getSelectedDEV && 'dev-selected-component']">
    <v-slider
      :name="schema.model"
      :id="setId(schema.model)"
      :rules="rules"
      :value="schema.value"
      v-bind="schema.attributes"
      :disabled="schema.readonly"
      v-model="value"
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    >
      <template v-slot:label>
        {{ schema.attributes.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-slider>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin],

  data() {
    return {
      required: v => v === 0 && `Este campo é obrigatório`
    };
  },

  methods: {
    onChange: async function() {
      this.changeEvents();
    },
    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    }
  }
};
</script>
